import React from 'react';

const Button = ({ 
  children, 
  onClick, 
  variant = 'primary', 
  className = '', 
  disabled = false, 
  fullWidth = false,
  size = 'md'
}) => {
  const variants = {
    primary: 'bg-accent-green hover:bg-accent-green/90 text-white shadow-lg shadow-accent-green/30',
    secondary: 'bg-accent-golden hover:bg-accent-golden/90 text-primary-black shadow-lg shadow-accent-golden/30',
    outline: 'border-2 border-accent-green text-accent-green hover:bg-accent-green/10',
    ghost: 'text-accent-green hover:bg-accent-green/10'
  };

  const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg'
  };
  
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={`
        rounded-xl font-semibold
        transition-all duration-200
        disabled:opacity-50 disabled:cursor-not-allowed
        ${fullWidth ? 'w-full' : ''}
        ${sizes[size]}
        ${variants[variant] || variants.primary}
        ${className}
      `}
    >
      {children}
    </button>
  );
};

export default Button;